// 基本配置
const shapeSize = [500, 500, 50, 30, 10]
const [width, height, size, w, padding] = shapeSize

export {
    width,
    height,
    size,
    w,
    padding
}